// src/pages/AlbaranesHub.jsx
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../hooks/usePermissions";
import { MODULES, ACTIONS } from "../utils/permissions";
import { Can } from "../components/PermissionGuard";

export default function AlbaranesHub() {
  const navigate = useNavigate();
  const { hasModuleAccess } = usePermissions();

  // Check if user has any access to albaranes
  if (!hasModuleAccess(MODULES.ALBARANES)) {
    return (
      <div className="container">
        <div className="header">
          <span className="badge">FIRMAS CEJM</span>
        </div>

        <div className="card" style={{ 
          textAlign: 'center', 
          padding: '48px 24px',
          background: '#fef2f2',
          border: '2px solid #fecaca'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
          <h2 style={{ color: '#dc2626', marginBottom: '8px' }}>Sin acceso a albaranes</h2>
          <p style={{ color: '#7f1d1d', margin: 0 }}>
            No tienes permisos para acceder al sistema de solicitudes de albaranes.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="header">
        <span className="badge">FIRMAS CEJM</span>
      </div>

      <h1 className="title">📦 Gestión de Albaranes</h1>

      <div className="card grid" style={{ gap: '24px' }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <p className="meta" style={{ fontSize: '16px', lineHeight: 1.5 }}>
            Desde aquí puedes crear nuevas solicitudes de albaranes o revisar las solicitudes existentes.
          </p>
        </div>

        {/* Opción 1: Crear Nueva Solicitud */}
        <Can module={MODULES.ALBARANES} action={ACTIONS.CREATE}>
          <div 
            className="card"
            style={{ cursor: 'pointer', transition: 'all 0.2s ease', border: '2px solid #16a34a', background: '#ffffff' }}
            onClick={() => navigate('/solicitar-albaran')}
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(22,163,74,0.15)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📝</div>
              <h2 style={{ margin: '0 0 12px 0', color: '#15803d', fontSize: '24px', fontWeight: 'bold' }}>
                Crear Nueva Solicitud
              </h2>
              <p style={{ margin: '0 0 16px 0', color: '#374151', fontSize: '16px', lineHeight: 1.4 }}>
                Solicita un nuevo albarán completando el formulario con todos los detalles necesarios.
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center', marginTop: '16px' }}>
                <span className="badge" style={{ background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0', fontSize: '12px' }}>✅ Formulario completo</span>
                <span className="badge" style={{ background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0', fontSize: '12px' }}>📋 Datos de entrega</span>
                <span className="badge" style={{ background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0', fontSize: '12px' }}>📧 Envío automático</span>
              </div>
            </div>
          </div>
        </Can>

        {/* Opción 2: Ver Solicitudes Existentes */}
        <Can module={MODULES.ALBARANES} action={ACTIONS.READ}>
          <div 
            className="card"
            style={{ cursor: 'pointer', transition: 'all 0.2s ease', border: '2px solid #3b82f6', background: '#ffffff' }}
            onClick={() => navigate('/historial-albaranes')}
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(59,130,246,0.15)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
              <h2 style={{ margin: '0 0 12px 0', color: '#1d4ed8', fontSize: '24px', fontWeight: 'bold' }}>
                Ver Solicitudes Existentes
              </h2>
              <p style={{ margin: '0 0 16px 0', color: '#374151', fontSize: '16px', lineHeight: 1.4 }}>
                Revisa el historial de solicitudes enviadas y gestiona los estados de los albaranes.
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center', marginTop: '16px' }}>
                <span className="badge" style={{ background: '#dbeafe', color: '#1e40af', border: '1px solid #bfdbfe', fontSize: '12px' }}>📊 Historial completo</span>
                <span className="badge" style={{ background: '#dbeafe', color: '#1e40af', border: '1px solid #bfdbfe', fontSize: '12px' }}>🔄 Cambio de estados</span>
                <span className="badge" style={{ background: '#dbeafe', color: '#1e40af', border: '1px solid #bfdbfe', fontSize: '12px' }}>📈 Seguimiento</span>
              </div>
            </div>
          </div>
        </Can>

        {/* Información adicional */}
        <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '10px', border: '1px solid #e2e8f0', textAlign: 'center', marginTop: '20px' }}>
          <h3 style={{ margin: '0 0 12px 0', color: '#374151' }}>💡 ¿Cómo funciona?</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px', marginTop: '16px' }}>
            <div>
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>1️⃣</div>
              <p className="meta" style={{ margin: 0, fontSize: '14px' }}><strong>Crear Solicitud:</strong> Completa el formulario con los detalles del albarán</p>
            </div>
            <div>
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>2️⃣</div>
              <p className="meta" style={{ margin: 0, fontSize: '14px' }}><strong>Envío Automático:</strong> La solicitud se envía automáticamente al almacén</p>
            </div>
            <div>
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>3️⃣</div>
              <p className="meta" style={{ margin: 0, fontSize: '14px' }}><strong>Seguimiento:</strong> Desde el historial se puede hacer seguimiento de estados</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}